import { z } from "zod"

export function buildPaginationSchema({
  minTotal = 1,
  maxTotal = 100,
}: {
  minTotal?: number
  maxTotal?: number
} = {}) {
  return z.object({
    page: z
      .union([z.string(), z.number()])
      .refine(
        (value) => {
          const numberValue = Number(value)
          return !Number.isNaN(numberValue) && numberValue > 0
        },
        {
          error: "Page must be a number and greater than 0",
        },
      )
      .transform(Number)
      .optional()
      .default(1),
    total: z
      .union([z.string(), z.number()])
      .refine(
        (value) => {
          const numberValue = Number(value)
          return !Number.isNaN(numberValue) && numberValue >= minTotal && numberValue <= maxTotal
        },
        {
          message: `Total must be a number, greater than or equal to ${minTotal} and less than or equal to ${maxTotal}`,
        },
      )
      .transform(Number)
      .optional()
      .default(100),
  })
}

export const PaginationSchema = buildPaginationSchema()
